<template>
  <div
    v-if="subscription && paid"
    class="text-center"
  >
    <p>
      <span class="display-block">{{ label }}</span>
      <strong class="display-block size-lg margin-top-2xs">{{ nextPaymentDate }}</strong>
    </p>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import get from 'lodash/get'
  import moment from 'moment'
  import { nextBilledSubscriptionAmount } from 'app/views/plans/priceUtils'

  export default {
    name: 'SubscriptionStatus',

    props: {
      subscription: {
        type: Object
      },
      determinations: {
        type: Object
      }
    },

    data() {
      return {
        isManaging: false
      }
    },

    computed: {
      paid() {
        return get(this.subscription, ['total', 'amount'], 0) > 0
      },

      nextAmount() {
        return nextBilledSubscriptionAmount(this.subscription)
      },

      nextPaymentDate() {
        const periodEndAt = get(this.subscription, ['periodEndAt'])
        const endedAt = get(this.subscription, ['endedAt'])
        const nextPaymentDate = periodEndAt ? periodEndAt : endedAt

        return moment.parseZone(nextPaymentDate).format('MMMM D, YYYY')
      },

      endDate() {
        return moment.utc(get(this.subscription, ['endedAtFormatted'])).format('MMMM D, YYYY')
      },

      label() {
        const { withinEndingGracePeriod, cancelAtPeriodEnd, ended } = this.determinations

        let val = `Your next payment of ${this.nextAmountFormatted()} occurs on:`


        if (cancelAtPeriodEnd) {
          val = 'Your subscription will end on:'
        }

        if (withinEndingGracePeriod || ended) {
          val = 'Your subscription, services, and updates ended on:'
        }

        return val
      },

      isStripe() {
        return get(this, ['subscription', 'type']) === 'stripe'
      },

      isBraintree() {
        return get(this, ['subscription', 'type']) === 'braintree'
      }
    },

    methods: {
      ...mapActions('billingPortal', ['requestBillingPortal']),

      async manageBilling() {
        this.isManaging = true

        try {
          const response = await this.requestBillingPortal()

          if ('url' in response) {
            window.location.href = response.url
          }
        } finally {
          this.isManaging = false
        }
      },

      nextYearDollars() {
        return this.nextAmount[0]
      },

      nextYearCents() {
        return this.nextAmount[1]
      },

      nextAmountFormatted() {
        if (this.nextYearCents()) {
          return `${this.nextYearDollars()}.${this.nextYearCents()}`
        }
        return this.nextYearDollars()
      }
    }
  }
</script>
